var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteAccountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 18L24 30M24 18L36 30M42 8H16L2 24L16 40H42C43.0609 40 44.0783 39.5786 44.8284 38.8284C45.5786 38.0783 46 37.0609 46 36V12C46 10.9391 45.5786 9.92172 44.8284 9.17157C44.0783 8.42143 43.0609 8 42 8Z",
    stroke: "#1E1E1E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccountIcon);
export default __webpack_public_path__ + "static/media/deleteAccountIcon.0d8948cadfb91e9ff48ab8a30bc8e52b.svg";
export { ForwardRef as ReactComponent };